import {
  UseFormRegister,
  FieldValues,
  FieldErrors,
  Controller,
  Control,
} from "react-hook-form";
import { Rules } from "../../types/integrations";
import { Switch } from "../ui/switch";
import { Field, FieldLabel, FieldError } from "../ui/field";

interface SwitchProps {
  label: string;
  name: string;
  rules: Rules;
  errors: FieldErrors<FieldValues>;
  register: UseFormRegister<FieldValues>;
  control?: Control<FieldValues, any>;
  hidden?: boolean;
}

export const FormSwitch = ({
  label,
  name,
  register,
  control,
  rules,
  errors,
  hidden,
}: SwitchProps) => {
  if (hidden) return null;

  return (
    <Field>
      <FieldLabel htmlFor={name}>
        {label}
      </FieldLabel>
      <div className="flex items-start justify-start">
        <Controller
          rules={rules}
          control={control}
          name={name}
          defaultValue="false"
          render={({ field: { onChange, value, ref } }) => (
            <Switch
              id={name}
              checked={value === "true" ? true : false}
              onCheckedChange={(checked) => {
                onChange(checked ? "true" : "false");
              }}
              ref={ref}
            />
          )}
        />
      </div>
      {errors[name] && (
        <FieldError>{`${errors[name]?.message}`}</FieldError>
      )}
    </Field>
  );
};
